// Bounded linear scan avoids regex on user-controlled params (ReDoS).
const ROUTE_PARAM_MAX_LENGTH = 2048

function isAlphanumericAscii (value) {
  if (value == null) return false
  const s = typeof value === 'string' ? value : String(value)
  if (s.length === 0 || s.length > ROUTE_PARAM_MAX_LENGTH) return false
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i)
    if (c >= 48 && c <= 57) continue
    if (c >= 65 && c <= 90) continue
    if (c >= 97 && c <= 122) continue
    return false
  }
  return true
}

export function alphabeticalParamGuard (paramName, redirectToError) {
  return (to, _, next) => {
    if (!isAlphanumericAscii(to.params[paramName])) next(redirectToError)
    next()
  }
}

export function alphanumericParamGuard (paramName, redirectToError) {
  return (to, _, next) => {
    if (!isAlphanumericAscii(to.params[paramName])) next(redirectToError)
    next()
  }
}

export function numericParamGuard (paramName, redirectToError) {
  return (to, _, next) => {
    if (isNaN(to.params[paramName])) next(redirectToError)
    next()
  }
}
